import React from "react";

export default () => (
  <div className="view-header d-flex align-items-center">
    <header className="text-white">
      <h1 className="h5 title text-uppercase">Exchange rate management</h1>
      <p className="mb-0 subtitle text-nowrap">
        Manage and
        <span className="hidden-sm-down"> update exchange rate</span>
      </p>
    </header>
  </div>
);



// WEBPACK FOOTER //
// ./src/views/exchange-rate/view-header.js